import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const Ctx = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(null);
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");
  const [overview, setOverview] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const refresh = useCallback(async () => {
    try { const r = await api.get("/overview"); setOverview(r.data); } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => {
    if (!user || user.role === "member") return;
    refresh();
    const id = setInterval(refresh, 20000);
    return () => clearInterval(id);
  }, [user, refresh]);

  const switchLang = (l) => { setLang(l); localStorage.setItem("lang", l); };
  const [view, setViewState] = useState(localStorage.getItem("view") || "demo");
  const setView = (v) => { setViewState(v); localStorage.setItem("view", v); };
  const logout = async () => { await api.post("/auth/logout"); setUser(false); };

  return <Ctx.Provider value={{ user, setUser, lang, switchLang, overview, refresh, logout, view, setView }}>{children}</Ctx.Provider>;
}

export const useApp = () => useContext(Ctx);
